import { ELanguage } from '@microfrontends/app-shell-v2'
import translate from '../resource/locale'

export default function t(key: string, resoure: string, language: ELanguage) {
	const translateResource = translate[resoure]
	if (language === ELanguage.EN) {
		return key
	}
	return translateResource[key]
}

export function customTranslation(resource: string, language: ELanguage) {
	const translateResource: {
		[key: string]: string
	} = translate[resource]
	return function (key: string) {
		if (language === ELanguage.EN) {
			return key
		}
		return translateResource[key] ?? key
	}
}

interface IResource {
	[key: string]: string
}

export const translator = (
	txt: string,
	resource: IResource,
	language: ELanguage
) => {
	switch (language) {
		case ELanguage.EN:
			return txt
		case ELanguage.VI:
			return resource[txt]
		default:
			return txt
	}
}
